import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
	selector: "app-payment-success",
	templateUrl: "./payment-success.component.html",
	styleUrl: "./payment-success.component.scss",
	standalone: false
})
export class PaymentSuccessComponent {
	esito;
	messaggio;
	constructor(private activatedRoute: ActivatedRoute) {
		activatedRoute.queryParams.subscribe(value => {
			// console.log(value);
			({
				esito: this.esito,
				messaggio: this.messaggio
			} = value);
		});
	}
}